import styled from 'styled-components';

export const Container = styled.div`
  animation: rendering 1s;
  width: 100%;

  transition: all 1s;
  min-height: 435px;

  @media (max-width: 420px) {
    min-height: 360px;
  }
  @media (max-width: 380px) {
    min-height: 332px;
  }

  > div:nth-of-type(1) {
    display: flex;
    flex-direction: column;
    margin: 0px auto;
    padding-top: 40px;
    padding-bottom: 40px;

    @keyframes rendering {
      from {
        transform: scale(0);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    > div.slick-slider {
      animation: rendering 1s ease-in;
      transition: all 1s;
      width: 100%;
    }
  }
`;

export const Spinner = styled.div`
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  border: 8px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--blue2c);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1.2s linear infinite;
  margin: 0 auto;
`;

export const Title = styled.div`
  font-family: 'Montserrat';
  font-size: 1.6rem;
  color: #000;
  width: 100%;
  margin: 0 auto;
  text-align: center;
  margin: 20px 0px;
`;

export const ExclusiveContent = styled.div`
  width: 280px;
  display: flex;
  justify-content: center;
  border-radius: var(--border20);
  font-family: 'Montserrat';
  font-size: 1.4rem;
  color: #fff;
  padding: 4px;
  background: linear-gradient(90deg, var(--purple6a) 0%, var(--purple84) 50%);
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;

  > div:nth-of-type(1) {
    font-family: 'Montserrat';
    font-weight: 700;
    font-size: 2rem;
    color: #000;
    width: 100%;
    margin-top: 2rem;
    text-align: flex-start;
  }

  @media (max-width: 1024px) {
    margin-left: 20px;
  }
`;

export const Description = styled.div`
  font-family: 'Montserrat';
  font-size: 2rem;
  color: #5c5c5c;
`;

export const ContainerSlider = styled.div`
  animation: rendering 1s;
  width: 100%;

  transition: all 1s;
  min-height: 435px;

  /* background: repeating-linear-gradient(
    -55deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.1) 1px,
    var(--light-bg) 1px,
    var(--light-bg) 15px
  ); */

  > div {
    display: flex;
    margin: 0px auto;
    padding-top: 20px;
    padding-bottom: 20px;

    @keyframes rendering {
      from {
        transform: scale(0);
        opacity: 0;
      }
      to {
        transform: scale(1);
        opacity: 1;
      }
    }

    div.slick-slider {
      width: 800px;
      margin: 0 auto;
      display: flex;
      align-items: center;

      > div.slick-list {
        width: 100%;
      }
    }
  }

  @media (max-width: 1220px) {
    > div {
      display: flex;
      flex-direction: column;
    }
  }

  @media (max-width: 900px) {
    > div {
      div.slick-slider {
        width: 600px;
      }
    }
  }

  @media (max-width: 700px) {
    > div {
      div.slick-slider {
        width: 400px;
      }
    }
  }

  @media (max-width: 420px) {
    min-height: 360px;
    > div {
      div.slick-slider {
        width: 300px;
      }
    }
  }
  @media (max-width: 380px) {
    min-height: 332px;
  }
`;

export const TextMostRecentEpisodes = styled.div`
  font-family: 'Montserrat';
  font-weight: 500;
  font-size: 1.8rem;
  margin-bottom: 20px;
`;

export const ContainerLatestSeries = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 320px;
`;
